import { createFileRoute } from '@tanstack/react-router';
import { RequireSignedIn } from '../app/layouts/guards';
import { OnboardingPage } from '../features/tenancy';

/** Onboarding (docs/04): light theme like the portal it leads to. */
export const Route = createFileRoute('/onboarding')({
  validateSearch: (search: Record<string, unknown>): { create?: boolean } =>
    search.create === true || search.create === 'true' ? { create: true } : {},
  component: function OnboardingRoute() {
    const { create } = Route.useSearch();
    return (
      <RequireSignedIn>
        <OnboardingPage forceCreate={Boolean(create)} />
      </RequireSignedIn>
    );
  },
});
